import { Box, styled } from '@mui/material';

export const ProductDetailsWrapper = styled(Box)(() => ({
  display: 'flex',
}));
